module.exports = __webpack_public_path__ + "static/img/BWCJ.db81152.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/BWCJ.png
// module id = zuog
// module chunks = 34